import './About.css';
import prideFlag from '../../images/pride.svg';
import { useEffect } from 'react';
import SEOHead from '../../components/SEOHead';
import { SEO_CONFIG, getCanonicalUrl } from '../../config/seo';

function About() {

  useEffect(() => {
    document.title = 'About | Phoenix Unity Designs';
  }, []);

  return (
    <>
      <SEOHead
        title={SEO_CONFIG.about.title}
        description={SEO_CONFIG.about.description}
        keywords={SEO_CONFIG.about.keywords}
        canonical={getCanonicalUrl(SEO_CONFIG.about.path)}
        ogUrl={getCanonicalUrl(SEO_CONFIG.about.path)}
      />
      <main id="main-content" tabIndex="-1" className='About page-container'>
      <div className='container mb-5'>
        <div className='row'>
          <div className='col'>
            <h1>About</h1>
            <p>We are an Ottawa based studio that prioritizes quality and meeting the client's needs.</p>
            <p>Supporting our local community is core to our values.</p>
            <p>We are a woman owned and operated business.</p>
            <p>Phoenix Unity Designs is an inclusive workplace. All are welcome, especially those who are subjected to inequity. <img src={prideFlag} className="pride-flag" alt="Intersex Inclusive Progressive Pride Flag" /></p>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}

export default About;
